export default {"src":"/_next/static/media/OriginalDark.2155f04d.svg","height":26,"width":117};